module.exports = __webpack_public_path__ + "3b8f72e702e0d188f2a72ae2129542f0.png";